<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div class="header-title">
              <h4 class="m-0 title-modal">FATCA</h4>
            </div>
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>

          <div class="modal-body">
            <div class="">
              <div class="p-3 pv-5">
                <span class="d-block">
                  A OZ Corretora de Câmbio é uma instituição financeira
                  participante do FATCA e que cumpre e cumprirá integralmente
                  com as obrigações de diligência e reporte decorrentes desta
                  legislação.
                </span>
               <br>
                <span class="d-block title-bold">O que é FATCA?</span>
                <span class="d-block">
                  Trata-se de uma lei americana sancionada em 18 de março de
                  2010, cujo objetivo resume-se em combater a evasão fiscal por
                  US Persons, os quais poderão deter contas/investimentos em
                  Instituições Financeiras não situadas nos EUA (“Foreign
                  Financial Institutions” ou “FFI’s”), e que não declarem ou não
                  tributem tais contas e/ou investimentos nos E.U.A.
                </span>
                <br />
                <span class="d-block title-bold">Como se caracteriza U.S. Person?</span>
                <span class="d-block">
                  Será caracterizado como U.S. Person aquela pessoa que seja:
                  
                </span>

                <span class="d-block">
                  (i) cidadão americano, ou seja, nascido nos EUA ou de seus
                  territórios, com pais americanos (cidadania derivada), com
                  cidadania americana (naturalização); 
                </span>

                <span class="d-block">
                  (ii) residente fiscal nos EUA, ou seja, possua green card ou tenha presença substancial
                  (31 dias durante um ano corrente e 183 dias durante o
                  triênio); e 
                </span>

                <span class="d-block">
                  (iii) sócio ou acionista de empresa constituída
                  sob as leis dos EUA (partnership doméstica ou sociedade
                  doméstica); 
                </span>

                <span class="d-block">
                  (iv) ainda, se uma U.S. Person detiver mais 10% ou
                  mais de participação direta ou indireta, societária ou
                  contratual, no lucro ou no capital de uma entidade (“US
                  Substantial Owner” ou “NFFEs”), esta deverá ser reportada.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
